"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M5 0H1a1 1 0 00-1 1v4h2V2h3V0zm13 15v3h-3v2h4a1 1 0 001-1v-4h-2zM0 18v-3h2v3h3v2H1a1 1 0 01-1-1v-1zM15 0h4a1 1 0 011 1v4h-2V2h-3V0zM8 0h4v2H8V0zm10 8v4h2V8h-2zM0 12V8h2v4H0zm12 6H8v2h4v-2z"];
//# sourceMappingURL=selection-box.js.map